import React, { useState, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import './ContactForm.css'
import Input from './Input'
import Modal from '../UI/Modal/Modal'
import checkValidity from './Validation'

const sitekey = '6Lc44usaAAAAAHmsN_KJq-r3e6NCMM_m3yNIoE9z'

const defaultContact = [
    {
        name: 'firstName',
        type: 'input',
        config: {
            type: 'text',
            id: 'firstname',
            placeholder: 'First Name',
        },
        value: '',
        validation: {
            required: true,
            notEmpty: true,
        },
        valid: true,

        focused: false,
    },
    {
        name: 'lastName',
        type: 'input',
        config: {
            type: 'text',
            id: 'lastname',
            placeholder: 'Last Name',
        },
        value: '',
        validation: {
            required: true,
            notEmpty: true,
        },
        valid: true,
        focused: false,
    },
    {
        name: 'email',
        type: 'input',
        config: {
            type: 'email',
            id: 'email',
            placeholder: 'Email',
        },
        value: '',
        validation: {
            required: true,
            email: true,
        },
        valid: true,
        focused: false,
    },
    {
        name: 'message',
        type: 'textarea',
        config: {
            type: 'textarea',
            id: 'message',
            placeholder: 'Say hello!',
        },
        value: '',
        validation: {
            required: true,
            notEmpty: true,
        },
        valid: true,
        focused: false,
    },
]

const contactForm = () => {
    const [contact, setContact] = useState(defaultContact)
    const [formValid, setFormValid] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [token, setToken] = useState(null)

    const recaptchaRef = useRef()

    const formSubmitHandler = () => {
        const reducedData = contact.reduce((data, input) => {
            data[input.name] = input.value
            return data
        }, {})

        reducedData.token = token

        const body = JSON.stringify(reducedData)

        const options = {
            method: 'POST',
            body,
        }

        fetch(
            'https://9th4mik5p2.execute-api.us-west-2.amazonaws.com/portfolioContact',
            options
        )
            .then(() => {
                setShowModal(true)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const inputChangedHandler = (event, index) => {
        const { value } = event.target
        const updateContact = [...contact]

        const valid = checkValidity(value, updateContact[index].validation)
        const updatedFormElement = {
            ...updateContact[index],
            value,
            focused: true,
            valid,
        }

        updateContact[index] = updatedFormElement

        const formValid = updateContact.every(
            (input) => !!input.valid && !!input.focused
        )

        setContact(updateContact)
        setFormValid(formValid)
    }

    const closeModalHandler = () => {
        recaptchaRef.current.reset()
        setContact(defaultContact)
        setFormValid(false)
        setShowModal(false)
        setToken(null)
    }

    const form = () => {
        const disabled = !formValid || !token
        return (
            <form>
                {contact.map((formItem, index) => {
                    const {
                        name,
                        type,
                        config,
                        value,
                        valid,
                        focused,
                        validation,
                    } = formItem
                    return (
                        <Input
                            key={name}
                            type={type}
                            config={config}
                            value={value}
                            label={config.id}
                            invalid={!valid}
                            focused={focused}
                            shouldValidate={validation.required}
                            changed={(event) =>
                                inputChangedHandler(event, index)
                            }
                        />
                    )
                })}
                {formValid && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={sitekey}
                        onChange={(token)=>setToken(token)}
                    />
                )}
                <button
                    onClick={formSubmitHandler}
                    disabled={disabled}
                    type="button"
                    className="btn center"
                >
                    Submit
                </button>
            </form>
        )
    }
    return (
        <div className="contact-container">
            <h2 className="section-title">Let's get in touch</h2>
            <div className="form-container">
                <Modal clicked={closeModalHandler} show={showModal}>
                    <div className="modal-container">
                        <div className="modal-icon-container">
                            <svg className="modal-icon">
                                <use xlinkHref="img/sprite.svg#icon-ic_done_black_24px" />
                            </svg>
                        </div>
                        <p className="modal-p">
                            Hi, {contact[0].value}, great to hear from you.
                            Thanks for reaching out - I'll be in touch soon!
                        </p>
                        <p className="centerText">Cheers, Christian!</p>
                    </div>
                </Modal>
                {form()}
            </div>
        </div>
    )
}
export default contactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js